<template>
  <div class="avatar">
    <SkeletonLoader v-if="isLoading" />
    <img
      v-show="!isLoading"
      class="avatar__image"
      :src="src"
      ref="avatarImage"
    />
  </div>
</template>

<script>
import SkeletonLoader from '@/_shared/components/ui/SkeletonLoader';
export default {
  components: {
    SkeletonLoader,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    this.$refs.avatarImage.onload = () => {
      this.isLoading = false;
    };
  }
}
</script>

<style scoped>
.avatar {
  height: 250px;
  max-height: 250px;
  width: 100%;
  margin: 0;
  display: inline-flex;
  text-align: center;
  align-items: flex-start;
  border-radius: 50%;
  cursor: default;
}
.avatar__image {
  border-radius: 50%;
  width: inherit;
  height: inherit;
  -o-object-fit: cover;
     object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/user/features/personal-area/Avatar.vue